<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!rule.displayOptions.active" (click)="rule.displayOptions.active = !rule.displayOptions.active; updateFilter()" [disabled]="reorder"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="showGoldenBorder">
    <app-select-item-and-base-type [rule]="rule" [disabled]="ruleControlsDisabled" [cosmetic]="cosmetic"></app-select-item-and-base-type>
    @if (!currencyItemTypes.includes(rule.itemType)) {
      <span class="sep"></span>
      <app-select-comparator [(ngModel)]="rule.rarityComparator" (selectedValueChange)="updateFilter()" [disabled]="ruleControlsDisabled"></app-select-comparator>
      <span class="sep"></span>
      <app-select-rarity [includeUnique]="true" [disabled]="ruleControlsDisabled" [(ngModel)]="rule.rarity" (selectedValueChange)="updateFilter();"></app-select-rarity>
    }
    @if (!isMobile() && enableRuleLabels) {
      <span class="sep"></span>
      <input type="text" class="form-control custom-rule-label-input" [(ngModel)]="rule.label" (ngModelChange)="updateFilter()"
        placeholder="Label" spellcheck="false" [disabled]="ruleControlsDisabled" (focus)="selectLabelText($event)" />
    }
    @if (!cosmetic) {
      <span class="sep"></span>
      <div app-select-tier tabindex="-1" style="display: table; width: 77px;"
        [disabled]="ruleControlsDisabled"
        [(tier)]="rule.displayOptions.displayTypeTier"
        [filter]="filter!"
        (updateFilter)="updateFilter()">
      </div>
    }
  </span>
  <span class="input-group-btn">
    <button class="btn toggle-button customize-btn" [class.no-conditions]="hasAdvancedConditions === 0" [class.active]="advancedConditionsOpen"
      [style.margin-right]="cosmetic ? '4px' : null"
      [disabled]="reorder"
      (click)="toggleAdvancedOptionsOpen()">
      <span class="icon icon-cog"></span>
      <span class="label">{{ hasAdvancedConditions }}</span>
    </button>
  </span>
  @if (cosmetic) {
    <span style="display: table;" app-cosmetic-controls
      [controls]="cosmeticControls"
      [rule]="rule"
      [displayable]="rule"
      [isDivinationCard]="rule.itemClass === 'Divination Cards'"
      [isPoe1Gem]="rule.itemClass === 'Skill Gems' || rule.itemClass === 'Support Gems'"
      [isCurrency]="currencyItemTypes.includes(rule.itemType)"
      [exampleName]="getExampleName(rule)"
      [rarity]="rule.rarity"
      [isWaystone]="rule.itemClass === 'Waystones'"
      [sockets]="rule.advancedConditions?.socketGroup ? ('L' + rule.advancedConditions?.socketGroup) : rule.advancedConditions?.minLinks ? ('L' + 'W'.repeat(rule.advancedConditions!.minLinks!)) : rule.advancedConditions?.minSockets ? ('W'.repeat(rule.advancedConditions!.minSockets!)) : undefined"
      [fractured]="rule.advancedConditions?.fractured"
      [synthesised]="rule.advancedConditions?.synthesised"
      [veiled]="rule.advancedConditions?.veiled"
      [influence]="rule.advancedConditions?.hasInfluence && rule.advancedConditions?.influences ? rule.advancedConditions!.influences![0] === 'All' ? 'Shaper' : rule.advancedConditions!.influences![0] : undefined"
      [disabled]="ruleControlsDisabled"
      [dirtyForceUpdate]="dirtyForceUpdate"
      (updateFilter)="updateFilter()"
    >
    </span>

    <span class="sep"></span>
    <div class="filter-title filter-label table-checkbox-group" [style.padding]="isMobile() ? '0px' : ''">
      <span class="input-group-btn">
        <button class="btn toggle-btn" title="Continue" [class.off]="!rule.continue" (click)="rule.continue = !rule.continue; updateFilter();" [disabled]="ruleControlsDisabled"></button>
      </span>
      @if (!isMobile()) {
        <span class="table-checkbox-label">
          <span class="filter-title-text">Partial</span>
          <div class="filter-tip"><p>Continue executing other rules further down the filter file, possibly overriding these styles.
            Use this if, for example, you only want to change the label style, but define a highlight further down.</p></div>
        </span>
      }
    </div>
    <span class="sep"></span>
  }
  @if (cosmetic) {
    <span class="input-group-btn">
      <app-cosmetic-style-options-menu
        [disabled]="ruleControlsDisabled"
        [getCopyOptions]="getRuleCopyOptions"
        [getCopyNameHint]="getRuleCopyNameHint"
        [applyPaste]="pasteStyle"
        [exampleName]="getExampleName(rule)"
        [rarity]="rule.rarity"
        [isCurrency]="currencyItemTypes.includes(rule.itemType)"
        [isDivinationCard]="rule.itemClass === 'Divination Cards'"
        [isPoe1Gem]="rule.itemClass === 'Skill Gems' || rule.itemClass === 'Support Gems'"
        [isWaystone]="rule.itemClass === 'Waystones'"
        [sockets]="rule.advancedConditions?.socketGroup ? ('L' + rule.advancedConditions?.socketGroup) : rule.advancedConditions?.minLinks ? ('L' + 'W'.repeat(rule.advancedConditions!.minLinks!)) : rule.advancedConditions?.minSockets ? ('W'.repeat(rule.advancedConditions!.minSockets!)) : undefined"
        [fractured]="rule.advancedConditions?.fractured"
        [synthesised]="rule.advancedConditions?.synthesised"
        [veiled]="rule.advancedConditions?.veiled"
        [influence]="rule.advancedConditions?.hasInfluence && rule.advancedConditions?.influences ? rule.advancedConditions!.influences![0] === 'All' ? 'Shaper' : rule.advancedConditions!.influences![0] : undefined">
        <button type="button" class="btn options-menu-item" title="Clone" (click)="cloneRule()" [disabled]="reorder">
          <span class="options-menu-clone-icon options-menu-icon" aria-hidden="true"></span>
          <span class="options-menu-label">Clone</span>
        </button>
      </app-cosmetic-style-options-menu>
    </span>
  } @else {
    <span class="input-group-btn">
      <button class="btn copy-rule-btn" title="Clone" (click)="cloneRule();" [disabled]="reorder"></button>
    </span>
  }
  <span class="input-group-btn">
    <button class="btn remove-btn" (click)="removeRule()" [disabled]="reorder"></button>
  </span>
</div>
@if(advancedConditionsOpen) {
  <div app-advanced-conditions-filter [rule]="rule" (updateFilter)="updateFilter()"></div>
}
@if (cosmetic) {
  <app-cosmetic-settings style="display: table;"
    [cosmeticOptions]="rule.displayOptions.cosmeticOptions!"
    [cosmeticControls]="cosmeticControls"
    [active]="cosmeticSettingsActive"
    filterClasses="filter-padded filter-double-padded-right"
    (updateFilter)="updateFilter()"
    >
  </app-cosmetic-settings>
}
